import { capitalize } from '../../../utils/capitalize';

/**
 * @typedef { Object } AsyncApiSelectors
 * @property { function } isFetchingMasses - When starts fetching
 * @property { function } anytimeFetchedMasses - When starts fetching
 */

/**
 * Create async actions
 * @param { string } key - key in redux state
 * @return { AsyncApiSelectors }
 */
export const createFetchSelectors = key => {
  return {
    [`isFetching${capitalize(key)}`]: state => state.fetch[key].loading,
    [`anytimeFetched${capitalize(key)}`]: state => state.fetch[key].anytimeFetched,
  };
};
